import { type PublicGlobalConfig } from '../../../global-config'
import { gtmDataLayerPush } from '../../../gtm'
import {
  urlResolverGetAccount,
  urlResolverGetAccountChangePage,
  urlResolverGetAccountOrders,
  urlResolverGetContactUs,
  urlResolverGetHelpCentrePharmaPage,
  urlResolverGetOrderQuestion,
} from '../../../url-handling'

const getContext = ({
  config,
  isModalOpen,
  pathName,
  referrer,
}: {
  config: PublicGlobalConfig
  isModalOpen?: boolean
  pathName: string
  referrer: string
}): string => {
  const url = isModalOpen ? pathName : referrer

  const referrerPaths = [
    urlResolverGetOrderQuestion(config),
    urlResolverGetHelpCentrePharmaPage(config),
    urlResolverGetAccountChangePage(config),
    urlResolverGetContactUs(config),
  ]

  if (
    referrer &&
    new URL(referrer).pathname === urlResolverGetAccount(config)
  ) {
    return 'account'
  }

  if (url.includes(urlResolverGetAccountOrders(config))) {
    return 'order'
  }

  if (referrerPaths.some((path) => url.includes(path))) {
    return 'amazonisation'
  }

  return 'other'
}

export const loginRegistrationGtmPushFullStoryPayLoad = ({
  config,
  isModalOpen,
  pathName,
}: {
  config: PublicGlobalConfig
  isModalOpen?: boolean
  pathName: string
}): void => {
  const { referrer } = document

  const context = getContext({ config, isModalOpen, pathName, referrer })

  gtmDataLayerPush({
    event: 'fs_page_prop',
    fs_page_properties: {
      context,
      pageName: 'login',
    },
  })
}
